/* global window */
export function getQueryParam(param, url = window.location.href) {
  const name = param.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * Parse the given JWT token
 *
 * @param {string} token
 * @returns {object}
 */
export function parseJwt(token) {
  let result = {};

  if (token) {
    const base64 = token.split('.')[1];
    const text = Buffer.from(base64, 'base64').toString('UTF-8');

    try {
      result = JSON.parse(text);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  }

  return result;
}

/**
 * Decode an access token
 *
 * @param {string} accessToken
 * @returns {object}
 */
export function parseAccessToken(accessToken) {
  const claims = parseJwt(accessToken);
  const {
    scope,
    sub: networkUserId,
  } = claims;
  const sessionId = claims.details?.session_id || null;
  const device = claims?.details?.device || null;
  const expiration = claims.exp * 1000;
  const userAgent = claims?.details?.user_agent || null;

  const [network] = networkUserId.split(':');

  const expired = Date.now() > expiration;

  return {
    networkUserId,
    network,
    device,
    sessionId,
    expiration,
    expired,
    scope,
    userAgent,
  };
}
